const okrugObjectsCardFields: any = [
    {
        field: "name",
        caption: "Наименование"
    },
    {
        field: "cad_num",
        caption: "Учетный номер"
    },
    {
        field: "cnt_kr",
        caption: "Количество кадастровых районов"
    },
    {
        field: "cnt_kk",
        caption: "Количество кадастровых кварталов"
    },
    {
        field: "cnt_land",
        caption: "Количество земельных участков"
    },
    {
        field: "cnt_oks",
        caption: "Количество объектов капитального строительства"
    },
    {
        field: "cnt_enk",
        caption: "Количество единых недвижимых комплексов"
    },
    {
        field: "cnt_pik",
        caption: "Количество предприятий как имущественных комплексов"
    }
]

const buildingObjectsCardFields: any = [
    {
        field: "build_record_registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "cad_num",
        caption: "Кадастровый номер"
    },
    {
        field: "quarter_cad_number",
        caption: "Кадастровый квартал"
    },
    {
        field: "readable_address",
        caption: "Адрес"
    },
    {
        field: "building_name",
        caption: "Наименование"
    },
    {
        field: "purpose",
        caption: "Назначение"
    },
    {
        field: "build_record_area",
        caption: "Площадь общая кв.м"
    },
    {
        field: "status",
        caption: "Статус"
    },
    {
        field: "ownership_type",
        caption: "Форма собственности"
    },
    {
        field: "cost_value",
        caption: "Кадастровая стоимость"
    },
    {
        field: "cost_index",
        caption: "Удельный показатель кадастровой стоимости"
    },
    {
        field: "floors",
        caption: "Количество этажей (в том числе подземных)"
    },
    {
        field: "underground_floors",
        caption: "Количество подземных этажей"
    },
    {
        field: "materials",
        caption: "Материал стен"
    },
    {
        field: "year_built",
        caption: "Завершение строительства"
    },
    {
        field: "year_commisioning",
        caption: "Ввод в эксплуатацию"
    },
    {
        field: "cultural_heritage_val",
        caption: "Сведения о включении объекта недвижимости в единый государственный реестр объектов культурного наследия (памятников истории и культуры) народов Российской Федерации"
    }
]
const constructionObjectsCardFields: any = [
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "cad_number",
        caption: "Кадастровый номер"
    },
    {
        field: "quarter_cad_number",
        caption: "Кадастровый квартал"
    },
    {
        field: "address_readable_address",
        caption: "Адрес"
    },
    {
        field: "params_name",
        caption: "Наименование"
    },
    {
        field: "params_purpose",
        caption: "Назначение"
    },
    {
        field: "status",
        caption: "Статус"
    },
    {
        field: "ownership_type",
        caption: "Форма собственности"
    },
    {
        field: "cost_value",
        caption: "Кадастровая стоимость"
    },
    {
        field: "cost_index",
        caption: "Удельный показатель кадастровой стоимости"
    },
    {
        field: "params_floors",
        caption: "Количество этажей (в том числе подземных)"
    },
    {
        field: "params_underground_floors",
        caption: "Количество подземных этажей"
    },
    {
        field: "params_year_built",
        caption: "Завершение строительства"
    },
    {
        field: "params_year_commisioning",
        caption: "Ввод в эксплуатацию"
    },
    {
        field: "cultural_heritage_val",
        caption: "Сведения о включении объекта недвижимости в единый государственный реестр объектов культурного наследия (памятников истории и культуры) народов Российской Федерации"
    }
]
const unfinishedBuildingObjectsCardFields: any = [
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "cad_num",
        caption: "Кадастровый номер"
    },
    {
        field: "quarter_cad_number",
        caption: "Кадастровый квартал"
    },
    {
        field: "readable_address",
        caption: "Адрес"
    },
    {
        field: "name",
        caption: "Наименование"
    },
    {
        field: "status",
        caption: "Статус"
    },
    {
        field: "ownership_type",
        caption: "Форма собственности"
    },
    {
        field: "cost_value",
        caption: "Кадастровая стоимость"
    },
    {
        field: "cost_index",
        caption: "Удельный показатель кадастровой стоимости"
    },
    {
        field: "degree_readiness",
        caption: "Степень готовности ОНС в процентах"
    },
    {
        field: "purpose",
        caption: "Проектируемое значение основной характеристики"
    },
    {
        field: "facility_cad_number",
        caption: "Кадастровый номер предприятия как имущественного комплекса, если объект незавершенного строительства (имущественное право на объект незавершенного строительства) входит в состав предприятия как имущественного комплекса"
    }
]
const landPlotTableObjectsColumns: any = [
    {
        field: "land_record_subtype",
        caption: "Вид земельного участка"
    },
    {
        field: "land_record_reg_date",
        caption: "Дата присвоения"
    },
    {
        field: "cad_num",
        caption: "Кадастровый номер"
    },
    {
        field: "quarter_cad_number",
        caption: "Кадастровый квартал"
    },
    {
        field: "readable_address",
        caption: "Адрес"
    },
    {
        field: "specified_area",
        caption: "Площадь уточненная"
    },
    {
        field: "status",
        caption: "Статус"
    },
    {
        field: "land_record_category_type",
        caption: "Категория земель"
    },
    {
        field: "permitted_use_established_by_document",
        caption: "Вид разрешенного использования"
    },
    {
        field: "ownership_type",
        caption: "Форма собственности"
    },
    {
        field: "cost_value",
        caption: "Кадастровая стоимость"
    },
    {
        field: "cost_index",
        caption: "Удельный показатель кадастровой стоимости"
    }
]
const ZOUITObjectsCardFields: any = [
    {
        field: "type_zone",
        caption: "Тип зоны"
    },
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "reg_numb_border",
        caption: "Реестровый номер границы"
    },
    {
        field: "cadastral_district",
        caption: "Кадастровый район"
    },
    {
        field: "old_account_number",
        caption: "Учетный номер"
    },
    {
        field: "name_by_doc",
        caption: "Наименование"
    },
    {
        field: "content_restrict_encumbrances",
        caption: "Ограничение"
    }
]

const forestryObjectsCardFields: any = [
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "reg_numb_border",
        caption: "Реестровый номер границы"
    },
    {
        field: "cadastral_district",
        caption: "Кадастровый район"
    },
    {
        field: "old_account_number",
        caption: "Учетный номер"
    },
    {
        field: "name_by_doc",
        caption: "Наименование"
    }
]
const coastlinesPolygonalObjectsCardFields: any = [
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "brd_nmb",
        caption: "Реестровый номер границы"
    },
    {
        field: "cadastral_district",
        caption: "Кадастровый район"
    },
    {
        field: "name",
        caption: "Наименование"
    }
]
const coastlinesLinearObjectsCardFields: any = [
    {
        field: "registration_date",
        caption: "Дата присвоения"
    },
    {
        field: "brd_nmb",
        caption: "Реестровый номер границы"
    },
    {
        field: "cadastral_district",
        caption: "Кадастровый район"
    },
    {
        field: "name",
        caption: "Наименование"
    }
]

export const rosreestrObjectsCardFields: any = {
    okrug: okrugObjectsCardFields,
    building: buildingObjectsCardFields,
    construction: constructionObjectsCardFields,
    unfinishedBuilding: unfinishedBuildingObjectsCardFields,
    landPlots: landPlotTableObjectsColumns,
    cultureZOUIT: ZOUITObjectsCardFields,
    serviceZOUIT: ZOUITObjectsCardFields,
    natureZOUIT: ZOUITObjectsCardFields,
    secureZOUIT: ZOUITObjectsCardFields,
    otherZOUIT: ZOUITObjectsCardFields,
    specialZOUIT: ZOUITObjectsCardFields,
    forestry: forestryObjectsCardFields,
    coastlinesPolygonal: coastlinesPolygonalObjectsCardFields,
    coastlinesLinear: coastlinesLinearObjectsCardFields
}